const getBrowserStorage = () => {
  if (typeof window === 'undefined') return null;
  if (window.localStorage) return window.localStorage;
  if (window.sessionStorage) return window.sessionStorage;
  return null;
};

const browserStorage = getBrowserStorage();

export default browserStorage;
